import { ContainerType, ElementPath } from '../typings/types';
import { useUserState } from '../firebaseWrapper/firebaseWrapper';
import { LogInForFeatureAlert } from './Alert';

/**
 * Shared logic behind every "+" add action: gates on the viewer being logged in (an
 * anonymous viewer without a logged-in group membership gets prompted to log in instead),
 * then opens CreateDialog pre-filled for the given type. Used by FloatingActionButton's menu
 * options and by the inline "add" buttons NothingHereInformation can render (see
 * GroupsScreen/GroupScreen/StatementScreen), so both paths to CreateDialog stay in sync.
 *
 * Kept in its own module (rather than inside FloatingActionButton.tsx, which pulls in Dialogs.tsx
 * and its unconditional react-native-localize import) so it stays unit-testable without a full
 * native-module mock -- see FloatingActionButton.test.tsx.
 */
export function useAddAction(
  navigation: any,
  parentInfo: ElementPath,
  groupId?: string,
  topicId?: string,
  memberId?: string,
): (typeId: ContainerType, possibleTypes: ContainerType[]) => void {
  const [user, loading] = useUserState();

  return (typeId: ContainerType, possibleTypes: ContainerType[]) => {
    if (loading || !user) {
      return;
    }
    user.isAnonymous && !memberId ?
      LogInForFeatureAlert()
      :
      navigation.push('CreateDialog', {
        typeId,
        possibleTypes,
        groupId,
        topicId,
        memberId,
        ...parentInfo,
      });
  };
}
